import type { SchemaViewerFormItemProps } from "./schema-viewer-form-item.type";

import { Form } from "antd";

import { SchemaViewerFormItemLabel } from "@/modules/schema-viewer/schema-viewer-form-item-label";

export const SchemaViewerFormItem = ({
  schema,
  isVisible = true,
  hidden,
  children,
  ...formItemProps
}: SchemaViewerFormItemProps) => {
  const { type, model, hint } = schema;
  const isCheckboxField = type === "checkbox";

  return (
    <Form.Item
      name={model}
      label={<SchemaViewerFormItemLabel schema={schema} />}
      valuePropName={isCheckboxField ? "checked" : "value"}
      extra={hint}
      hidden={hidden ? true : !isVisible}
      style={{ marginLeft: 15 }}
      {...formItemProps}
    >
      {children}
    </Form.Item>
  );
};
